// extracted by mini-css-extract-plugin
export default {"wrapper":"HorseDeleteModal_wrapper__vc9wO","icon":"HorseDeleteModal_icon__wdrY2","heading":"HorseDeleteModal_heading__cy0Ls"};